import { gql, useQuery } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

export const CHANGE_TYPE_REASONS_QUERY = gql`
  query ChangeTypeReasons($changeType: ChangeType) {
    changeTypeReasons(changeType: $changeType) {
      cancelRenewal {
        display
        value
        show
      }
      statusCode
    }
  }
`;

export function useChangeTypeReasons(changeType) {
  const { data, loading, error } = useQuery(CHANGE_TYPE_REASONS_QUERY, {
    noThrow: true,
    variables: { changeType }
  });

  useError(error);

  return {
    data: data?.changeTypeReasons,
    loading,
    hasError: Boolean(error),
    error
  };
}
